import { ref } from 'vue';
import http from './http';

export default function () {
    const loading = ref(false);
    const showModal = ref(false);
    const announcement = ref();
    const scrollbarRef = ref(null);


    async function read() {
        loading.value = true;
        try {
            const url = '/api/app/announcement/read';
            const res = await http.request("get", url);

            if (res.Type == 200 && res.Data != null) {
                announcement.value = res.Data;
                showModal.value = true;
            }
            return !showModal.value; 
        } finally {
            loading.value = false;
        }
    }


    async function onAccept() {
        loading.value = true;
        try {
            const res = await http.request("post", "/api/app/announcement/accept");
            if (res?.Type == 200) {
                showModal.value = false;
            }
        } finally {
            loading.value = false;
        }
    }

    return { loading, read, showModal, announcement, scrollbarRef, onAccept };
}